import React from 'react';
// import { Bar, HorizontalBar, Line } from 'react-chartjs-2';
// import {lineChartOptions, chartDataVertical} from '../chart/config';
import { Collapse, Button, Radio, Icon, Tooltip } from 'antd';
import {dataTable, getPlurals} from '../utils/utils';

const Panel = Collapse.Panel;

class ChartRenderProp extends React.Component {

  constructor(props) {
    super(props);
    //console.log('constructor', this)
    this.setRef = this.setRef.bind(this);
    this.state = {
      active: false,
      chart: undefined,
    }
  }
  setRef(node) {
    this.chart = node 
    //console.log('set ref', node, 'this.chart', this.chart)
  }
  onChange(key) {
    this.setState({
      active: !this.state.active,
    })
  }
  onDownloadImage(e) {
    let link = document.createElement("a");
    link.download =  `${this.props.tableName}.png`;
    //console.log('onDownloadImage in chart render props this', this);
    link.href = this.chart.chartInstance.toBase64Image();
    link.click();
    e.preventDefault();
  }

  componentDidMount() {
  //console.log('componentDidMount this.chart', this.chart)
    this.setState({ chart: this.chart });
  }

 render() {
    const { chart } = this.state;
    //console.log('ChartRenderProp props', this)

    return (

      <Collapse accordion defaultActiveKey={['1']}  onChange={this.onChange.bind(this)}>
        <Panel showArrow={false} header={this.props.header()} key="1" forceRender={true}>
              {this.props.render(this.setRef)}
            <div className="download">
              <a onClick={this.onDownloadImage.bind(this)}>
                <Tooltip title="Download chart as image">
                  <Button type="primary" icon="download" size="large" >Image</Button>
                </Tooltip>
              </a>
            </div>
        </Panel>
      </Collapse>
  )
 }
}
export default ChartRenderProp;



// WEBPACK FOOTER //
// ./src/components/ChartRenderProp.js